var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page_error"},[_c('div',[_c('v-icon',{staticClass:"error_icon"},[_vm._v("cloud_off")])],1),_vm._m(0)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"error_text"},[_c('h1',[_vm._v("502")]),_c('h3',[_vm._v("Bad gateway")]),_c('p',[_vm._v("O servidor encontrou um erro temporário e não pôde concluir sua solicitação.")])])
}]

export { render, staticRenderFns }